import React from 'react';

import CalendarRoot from './components/CalendarRoot';
import CalendarHeader from './components/CalendarHeader';
import CalendarNavigation from './components/CalendarNavigation';
import CalendarGrid from './components/CalendarGrid';
import CalendarTimeColumn from './components/CalendarTimeColumn';
import CalendarDay from './components/CalendarDay';
import CalendarDayHeader from './components/CalendarDayHeader';
import CalendarEvent from './components/CalendarEvent';
import CalendarTimeSlot from './components/CalendarTimeSlot';
import CalendarCurrentTimeLine from './components/CalendarCurrentTimeLine';
import CalendarEmpty from './components/CalendarEmpty';

import MobileCalendarRoot from './mobile/MobileCalendarRoot';
import MobileWeekStrip from './mobile/MobileWeekStrip';
import MobileDayView from './mobile/MobileDayView';
import MobileEventItem from './mobile/MobileEventItem';
import MobileNavigation from './mobile/MobileNavigation';

const Calendar = ({ children, ...props }) => {
  return (
    <CalendarRoot {...props}>
      {children}
    </CalendarRoot>
  );
};

Calendar.Root = CalendarRoot;
Calendar.Header = CalendarHeader;
Calendar.Navigation = CalendarNavigation;
Calendar.Grid = CalendarGrid;
Calendar.TimeColumn = CalendarTimeColumn;
Calendar.Day = CalendarDay;
Calendar.DayHeader = CalendarDayHeader;
Calendar.Event = CalendarEvent;
Calendar.TimeSlot = CalendarTimeSlot;
Calendar.CurrentTimeLine = CalendarCurrentTimeLine;
Calendar.Empty = CalendarEmpty;

Calendar.Mobile = MobileCalendarRoot;
Calendar.MobileWeekStrip = MobileWeekStrip;
Calendar.MobileDayView = MobileDayView;
Calendar.MobileEventItem = MobileEventItem;
Calendar.MobileNavigation = MobileNavigation;

export default Calendar;
